import React, { PureComponent } from 'react'

import { getCurrentYear } from '../../utils/time'

export default class UnauthenticatedFooter extends PureComponent {
  render() {
    return (
      <div className="container">
        <div
          className="logo"
          onClick={() => window.open('https://www.opportunityeducation.org/')}
        />
        <div className="copyright">
          &copy;&nbsp;
          {`${getCurrentYear()} Opportunity Education. All rights reserved.`}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footers/UnauthenticatedFooter.js